<template>
<main>


    <!-- breadcrumb area end -->
    
    <div class="container" v-if="this.selectedSinleStore != undefined">
        <div class="row"><div class="col-24">Afspraak opmaken in salon <strong>{{this.selectedSinleStore.UserName}}</strong> <br> {{getSalonAdres (this.selectedSinleStore.Location)}}</div></div>
    </div>

    <div class="container" v-if="this.storeCustomer != undefined">
        <div class="row"><div class="col-24">Afspraak opmaken voor <strong>{{this.storeCustomer.FirstName}}  {{this.storeCustomer.LastName}}</strong></div></div>
    </div>
     <div class="row">
        <div class="col-lg-12 col-sm-24">&nbsp;</div>
    </div>
<div>
  <div v-if="cart.length > 0">
    <div class="container">

      <div class="row">
        <div class="col-lg-12 col-sm-24 col-md-24" v-if="getHasStoreMsg" style="margin-bottom:15px">
          <div class="row" style="background-color:#edefef;border-radius:7px;padding:15px;margin:5px;word-wrap: break-word;"><span v-html="getStoreMsg" style="word-wrap: break-word;width:90%"></span></div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-16 col-xs-24">
          <div class="row">&nbsp;&nbsp;<h5>Jouw behandelingen</h5></div>
          <div class="row titleMenuBasket" v-bind:style="{ 'background-color': getColorApp}">&nbsp;&nbsp;</div>
          <div class="row">&nbsp;&nbsp;</div>
          <template v-for="product in cart">
            <cart-item :product="product"></cart-item>
            <cart-item-user-lst :product="product" v-if="!getUserSelectAllowed" @user-select-forprod="onselectUserList"></cart-item-user-lst>
            <div class="row" style="height:10px;">&nbsp;</div>
          </template>

             <div id="overlayUsers">
              <div style="margin:20px;padding:20px;background-color:#ffffff;border-radius:15px;border-color:#111111">
                <h3 style="margin-bottom:10px">Kies behandelaar voor</h3>
                <div style="margin-bottom:10px;">{{this.getProductName}}</div>
                <template  v-for="usr in selectedUsers">
                    <cart-item-user :user="usr" :product="selectedProd" @user-select-event="selectUserEvt"></cart-item-user>
                </template>
              </div>
            </div>

          <div class="row"  v-if="getTotalsAdvance () > 0" style="background-color:#999999;height:30px;line-height: 30px;border-radius:5px;padding-left:5px">
              <div class="col-18"><strong style="color:#ffffff">Totaal voorschot gevraagd van </strong></div>
              <div class="col-6" style="color:#ffffff;text-align:right">&euro;{{getTotalsAdvancePrice ()}}&nbsp;&nbsp;</div>
          </div>
          <div class="row">&nbsp;</div>
          <div class="row">
             <div class="col-13">
                <router-link :to="navRoot" class="product-link">
                     <div class="row product-btn" ><a style="color:#111111"><i class="ion-plus" style="color:#111111" ></i>Extra behandeling</a></div>
                  </router-link>
             </div>
             <div class="col-1"></div>
             <div class="col-10" style="float:right">
                 <div class="row product-btn" ><a @click="checkOut();" v-bind:style="{ 'background-color': getColorApp, color: '#ffffff'}"><i class="ion-bag" ></i>Volgende</a></div>
             </div>
          </div>
       </div>

      </div>
      <div class="row">&nbsp;</div>
       <div class="row">
              <div class="col-12">
                  
                  <router-link :to="navRoot" class="product-link">
                  <div class="row product-btn" >
                          <a style="color:#111111"><i class="ion-arrow-left-c" style="color:#111111"></i>Terug</a>
                        </div>
                  </router-link>
              </div>
        </div>      
        <div class="row">
        <div class="col-24">&nbsp;</div>
        </div>
        <div class="row col-24">&nbsp;</div>
        </div> 
    <div>
  </div>

  </div>
  <div v-else class="title">
    <div class="container">
          <div class="row">
            <div class="col-12">
              <h5><i class="fa fa-superpowers"></i> Winkelmand is leeg</h5><br>
            </div>
          </div>
           <div class="row">
             <div class="col-12">
                <router-link :to="navRoot" class="product-link">
                <div class="product-btn product-btn__color">
                    <a v-bind:style="{ 'background-color': getColorApp, color: '#ffffff'}"><i class="ion-arrow-left-c" ></i>Terug</a>
                  </div>
                </router-link>
              </div>
             </div>
          </div>
      </div>
    </div>
</div>
</main>
</template>
<style>
.titleMenuBasket
{
    
    left: 0;
    width: 180px;
    height: 3px;
    content: "";
}

#overlayUsers {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  max-width: 350px;
  margin:0 auto;
  top: 0%;
  left: 0%;
  right: 0%;
  bottom: 0%;
  background-color: rgba(250,250,250,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}

</style>

<script>
import Vue from 'vue';
import CartItemUser from '../components/cart/CartItemUser';
import CartItem  from '../components/cart/CartItem';
import CartItemUserLst from '../components/cart/CartItemUserLst.vue';

  export default {
    metaInfo: {
        title: 'Winkelmand'
    },
    data () {
      return {
        cart: this.$store.state.cart,
        storeCustomer : undefined,
        selectedSinleStore : undefined,
        selectedProd : undefined,
        selectedUsers : undefined,
        getProductName : '',
        currentUserBlock : undefined
      }
    },
    components: {
        cartItem : CartItem,
        cartItemUser : CartItemUser,
        cartItemUserLst : CartItemUserLst
    },
    methods: {
      selectUserEvt (user) {
          document.getElementById("overlayUsers").style.display = "none";
          this.selectedProd.SelectedUserID = user.UserID;
          this.currentUserBlock.setUser (user);
      },
      onselectUserList (ctrl, prod, users) {
        console.log (ctrl);
        this.selectedProd = prod;
        this.selectedUsers = users;
        this.getProductName = prod.Title;
        document.getElementById("overlayUsers").style.display = "block";
        this.currentUserBlock = ctrl;
      },
      getSalonAdres (locationname) {
         var arr = locationname.split (",");
         if (arr.length > 1) return arr[1];
         return locationname;
      },
      checkOut () {
        this.$router.push('/DateAppoint');
      },
      getTotalsAdvance () {
        var tot = 0
        for (var c=0; c < this.cart.length; c++) {
           tot += this.cart[c].PriceAdvance
        }
        return tot;
      },
      getTotalsAdvancePrice () {
        var t = this.getTotalsAdvance ()
        return t.toFixed (2)
      },
      navigate (item) {
        this.$router.push(item);
      },
      navigateBack () {
        this.$router.go(-1);
      }
    },
    mounted () {
      this.storeCustomer = Vue.$storeCustomer;
      this.selectedSinleStore = Vue.$selectedStore;
    },
    created () {

    },
     computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
       getUserSelectAllowed () {
           return Vue.$storeSettings.IsHideUsers;
       },
       getHasStoreMsg () {
           if (Vue.$storeSettings.MessageBasket == undefined) return false;
           if (Vue.$storeSettings.MessageBasket == null) return false;
           if (Vue.$storeSettings.MessageBasket.length < 20) return false;

           //Check indien leeg (enkel html tags)
           var msg = Vue.$storeSettings.MessageBasket;
           var regex = /(<([^>]+)>)/ig
           var msgRes = msg.replace  (regex, "");
           if (msgRes.length < 3) return false;

           return Vue.$storeSettings.IsBasketMessage;
       },
       getStoreMsg () {
           return Vue.$storeSettings.MessageBasket;
       },
       navRoot () {
          //return Vue.$baseUrl;
          if (this.selectedSinleStore != undefined) {
             return '/saloncategories';
          }
          else
          {
             return Vue.$baseUrl;
          }
       }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/Cart.vue